import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Box } from "@mui/system";

/* import {
  PuissanceMonophase,
  PuissanceTriphase,
} from "../../pages/demande/ListPuissance/puissanceBranchement"; */
import { PuissanceMonophase } from "../../pages/demande/ListPuissance/PuissanceMonophase";
import { PuissanceTriphase } from "../../pages/demande/ListPuissance/PuissanceTriphase";
import { Tableau } from "../../pages/demande/ListPuissance/Tableau";

const styles = { color: "black", fontWeight: "bold" };

export default function BranchAvecAbonDiag({
  addBranchement,
  branchement,
  open,
  onClose,
}) {
  /*  const [open, setOpen] = React.useState(false); */
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [errors, setErrors] = React.useState({});
  const [puissances, setPuissances] = React.useState([]);
  const [showTableau, setShowTableau] = React.useState(true);
  const [formData, setFormData] = React.useState({
    branchement: "monophasé", // triphasé
    amperage: "3A",
    nombre: "1",
    tableau: "",
  });

  //Gérer les puissances en fonction du types d'ampérange
  React.useEffect(() => {
    setPuissances(PuissanceMonophase);
    setShowTableau(true);
    if (formData.branchement === "monophasé") {
      setFormData((prevData) => ({
        ...prevData,
        amperage: PuissanceMonophase[0].key,
      }));
    } else {
      setPuissances(PuissanceTriphase);
      setShowTableau(false);
      setFormData((prevData) => ({
        ...prevData,
        amperage: PuissanceTriphase[0].key,
      }));
    }
  }, [formData.branchement]);

  React.useEffect(() => {
    if (
      formData.branchement === "monophasé" &&
      (formData.amperage === "10A" || formData.amperage === "15A")
    ) {
      setFormData((prevData) => ({
        ...prevData,
        tableau: Tableau[0].key,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        tableau: "",
      }));
    }
  }, [formData.amperage]);

  React.useEffect(() => {
    if (branchement) {
      setFormData({
        branchement: branchement.branchement,
        amperage: branchement.amperage,
        nombre: branchement.nombre,
        tableau: branchement.tableau,
      });
    }
  }, [branchement]);

  const handleChange = (field, value) => {
    if (field === "nombre" && (isNaN(value) || value < 1)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        nombre: "Valeur invalide",
      }));
      return;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, nombre: "" }));
    }
    setFormData((prevData) => ({ ...prevData, [field]: value }));
  };

  // Enregistrement de branchement
  const handleSubmit = () => {
    addBranchement(formData);
    onClose();
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={onClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="bg-blue-800 text-white font-black"
        >
          Ajout Branchement
        </DialogTitle>
        <DialogContent className="m-4 shadow-md ">
          <DialogContentText>
            <Box className=" space-y-4 mt-8 mb-8">
              <Box component="div">
                <InputLabel id="demo-select-small-label" sx={styles}>
                  Type de branchement
                </InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={formData.branchement}
                  label="type_amperage"
                  size="small"
                  variant="outlined"
                  sx={{ width: "100%" }}
                  onChange={(e) => handleChange("branchement", e.target.value)}
                >
                  <MenuItem value="monophasé">Monophasé</MenuItem>
                  <MenuItem value="triphasé">Triphasé</MenuItem>
                </Select>
              </Box>
              <Box
                component="div"
                className="flex md:justify-between md:flex-row sm:flex-row space-x-8"
              >
                <Box component="div" className="text-black font-medium">
                  Monophasé (02 fils)
                  <Box component="p">
                    Pour les applications domestiques et les petits appareils.
                  </Box>
                </Box>
                <Box component="div" className="text-black font-medium">
                  Triphasé ( 04 fils)
                  <Box component="p">
                    Pour les grandes installations industrielles et
                    commerciales.
                  </Box>
                </Box>
              </Box>
              <Box component="div" className="space-y-1">
                <InputLabel htmlFor="puissance" sx={styles}>
                  Ampérage souhaité
                </InputLabel>
                <Select
                  labelId="puissance"
                  id="puissance"
                  aria-label="Sélectionnez l'ampérage souhaité"
                  value={formData.amperage}
                  label="puissance"
                  size="small"
                  variant="outlined"
                  sx={{ width: "100%" }}
                  onChange={(e) => handleChange("amperage", e.target.value)}
                >
                  {/*{puissances}*/}
                  {puissances.map((k) => (
                    <MenuItem key={k.key} value={k.key}>
                      {k.value}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              {showTableau &&
                formData.branchement === "monophasé" &&
                (formData.amperage === "10A" ||
                  formData.amperage === "15A") && (
                  <>
                    <InputLabel id="tableau">Type de Tableau</InputLabel>
                    <Select
                      labelId="tableau"
                      id="tableau"
                      fullWidth
                      size="small"
                      variant="outlined"
                      value={formData.tableau}
                      onChange={(event) => {
                        handleChange("tableau", event.target.value);
                      }}
                      required
                    >
                      {Tableau.map((k) => (
                        <MenuItem key={k.key} value={k.key}>
                          {k.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {/*   {alertTableau && (
                                  <p style={{ color: "red" }}>{errors.tableau}</p>
                                )} */}
                  </>
                )}
              <Box component="div" className="space-y-1">
                <InputLabel htmlFor="nbtableau" sx={styles}>
                  Nombre de tableau
                </InputLabel>
                <TextField
                  /*  label="Nombre de Tableau" */
                  fullWidth
                  id="nbtableau"
                  labelId="nbtableau"
                  size="small"
                  value={formData.nombre}
                  type="number"
                  onChange={(e) =>
                    handleChange("nombre", e.target.value.toUpperCase())
                  }
                  error={!!errors.nombre}
                  helperText={errors.nombre}
                  required
                />
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={onClose}
            color="error"
            variant="contained"
            size="small"
          >
            Fermer
          </Button>
          <Button
            onClick={handleSubmit}
            autoFocus
            color="success"
            variant="contained"
            size="small"
          >
            Valider
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
